import { useEffect } from 'react';

/** Keyboard shortcuts for MapView. */
export function useMapShortcuts({ fitToData, setDrawMode, undoLastDrawn, setTool, setViewMode, resetMeasure, clearPopups }) {
  // ── 9.8 Keyboard shortcuts: V select · H pan · M measure · Esc cancel ·
  //    F fit to data · 1/2/3 basemaps · Ctrl+Z undo drawing ──
  useEffect(() => {
    const onKey = (e) => {
      const t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return;
      if (e.ctrlKey && !e.shiftKey && e.key.toLowerCase() === 'z') { e.preventDefault(); undoLastDrawn(); return; }
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      switch (e.key.toLowerCase()) {
        case 'v': setTool('select'); break;
        case 'h': setTool('pan'); break;
        case 'm': setTool('measure'); break;
        case 'f': fitToData(); break;
        case '1': setViewMode('map'); break;
        case '2': setViewMode('satellite'); break;
        case '3': setViewMode('topo'); break;
        case 'escape':
          setDrawMode(null);
          setTool('select');
          resetMeasure();
          clearPopups();
          break;
        default: break;
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [fitToData, setDrawMode, undoLastDrawn, setTool, setViewMode, resetMeasure, clearPopups]);
}
